import {IsString, Range, ToJSON} from "js-vextensions";
import Moment from "moment";
import {Button, Column, Div, Row, Select, Text, TextArea} from "react-vcomponents";
import {BaseComponent, BaseComponentWithConnector, BaseComponentPlus} from "react-vextensions";
import {AddTimelineEvent, DeleteTimelineEvent, UpdateTimelineEvent} from "../../../Server/Commands/TimelineEventCommands.js";
import {Activity} from "../../../Server/DB/activities/@Activity.js";
import {VDateTime, Observer, RunInAction} from "web-vcore";
import {ES} from "web-vcore";
import {GetTimelineEvents, GetTimelineEventsIntersectingRange, GetTimelineEventsIntersectingRange_SleepScheduleMode, GetTimelineEventsIntersectingRange_VisualizationMode} from "../../../Server/DB/timelineEvents.js";
import {ShowMessageBox} from "react-vmessagebox";
import {runInAction} from "mobx";
import {store} from "../../../Store/index.js";
import {GetActivities} from "../../../Server/DB/activities.js";
import {TimelineEvent} from "../../../Server/DB/timelineEvents/@TimelineEvent.js";
import React, {useState} from "react";
import {observer_mgl} from "mobx-graphlink";

export const TimelineRow = observer_mgl((props: {timelineID: string, startTime: number, endTime: number, index: number, last: boolean})=>{
	const {startTime, endTime, timelineID, index, last} = props;
	const uiState = store.main.timeline;
	const [expanded, setExpanded] = useState(false);

	const events =
		uiState.specialDisplayMode == "sleepSchedule" ? GetTimelineEventsIntersectingRange_SleepScheduleMode(timelineID, startTime, endTime) :
		uiState.specialDisplayMode == "visualization" ? GetTimelineEventsIntersectingRange_VisualizationMode(timelineID, startTime, endTime) :
		GetTimelineEventsIntersectingRange(timelineID, startTime, endTime);
	const activities = GetActivities(timelineID);
	const expandedOrLast = expanded || last;
	const rowHeight_final = uiState.rowHeight + (expandedOrLast ? 1 : 0);

	return (
		<Column>
			<Row
					style={{
						position: "relative", height: rowHeight_final, borderTop: index != 0 ? "1px solid rgba(255,255,255,.3)" : "1px solid transparent",
						borderBottom: expandedOrLast ? "1px solid rgba(255,255,255,.3)" : "none", cursor: "pointer",
					}}
					onClick={()=>{
						setExpanded(!expanded);
					}}>
				<Div ml={10} style={{float: "left", zIndex: 1, fontSize: 12, color: "rgba(255,255,255,.7)"}}>
					{Moment(startTime).format("YYYY-MM-DD (ddd)")}
				</Div>
				{events.map(event=>{
					const eventEndTime = event.endTime || Date.now();
					const eventStart_percentFromLeftToRight = Moment(event.startTime).diff(startTime) / Moment(endTime).diff(startTime);
					const eventWidth_percentOfChartWidth = Moment(eventEndTime).diff(event.startTime).KeepAtLeast(0) / Moment(endTime).diff(startTime);
					return <EventUI key={event.startTime} event={event} xPosPercent={eventStart_percentFromLeftToRight}
						widthPercent={eventWidth_percentOfChartWidth} activities={activities}/>;
				})}
				<div style={{position: "absolute", left: 0, right: 0, top: 0, bottom: 0, pointerEvents: "none"}}>
					{Range(0, 23).map(hour=>{
						return <div key={hour} style={{position: "absolute", left: `${(hour / 24) * 100}%`, width: 1, height: "100%", background: "rgba(128,128,128,.25)"}}/>;
					})}
				</div>
			</Row>
			{expanded &&
				<Column>
					<Row style={{height: 40, padding: 10}}>
						<Row>Events:</Row>
						<Row ml="auto">
							<Button text="Add event" onClick={()=>{
								const newEvent = new TimelineEvent({timeline: timelineID, activity: activities[0].id,
									startTime, endTime: Moment(startTime).add(1, "hour").valueOf()});
								new AddTimelineEvent({entry: newEvent}).RunOnServer();
							}}/>
						</Row>
					</Row>
					{events.map((event, eventIndex)=>{
						return <EventEditorUI key={eventIndex} event={event} index={eventIndex} last={eventIndex == events.length - 1} activities={activities} dayStartTime={startTime}/>;
					})}
				</Column>}
		</Column>
	);
});

const EventUI = observer_mgl((props: {event: TimelineEvent, xPosPercent: number, widthPercent: number, activities: Activity[]})=>{
	const {event, xPosPercent, widthPercent, activities} = props;
	const activity = activities.filter(a=>a.id == event.activity)[0];
	const timeInMins = Moment(event.endTime || Date.now()).diff(event.startTime, "minutes");
	return (
		<Div style={{
			position: "absolute", left: `${xPosPercent * 100}%`, width: `${widthPercent * 100}%`, height: "100%",
			minWidth: 1, backgroundColor: activity ? `rgba(${activity.color})` : "",
		}}>
			<Column style={{position: "absolute", bottom: 0, width: "100%", height: 12}}>
				<div style={{width: "100%", height: "50%", background: "rgba(0,0,0,.5)", clipPath: "ellipse(50% 100% at 50% 100%)"}}/>
				<div style={{width: "100%", height: "50%", background: "rgba(0,0,0,.5)"}}/>
				<div style={{position: "absolute", left: 0, right: 0, top: 0, bottom: 0, textAlign: "center", fontSize: 10, color: "white"}}>
					{timeInMins}
				</div>
			</Column>
		</Div>
	);
});

const EventEditorUI = observer_mgl((props: {event: TimelineEvent, index: number, last: boolean, activities: Activity[], dayStartTime: number})=>{
	const {event, index, last, activities, dayStartTime} = props;
	return (
		<Column p="7px 10px" style={ES(
			{background: "rgba(0,0,0,.7)", borderTop: "1px solid rgba(255,255,255,.3)"},
		)}>
			<Row center>
				<Text style={{flexShrink: 0}}>{index + 1}) </Text>
				<Text>Start time: </Text>
				<VDateTime dateFormat={false} value={event.startTime ? Moment(event.startTime) : null} max={event.endTime ? Moment(event.endTime) : null} onChange={val=>{
					/*if (IsString(val)) {
						let newTime_today = Moment(val.toString(), ["h:m a", "H:m"]);
						let newTime_correctDay = Moment(event.startTime).set({hour: newTime_today.get("hour"), minute: newTime_today.get("minute")});
					} else {
						var newTime_correctDay = val;
					}
					let updates = {startTime: newTime_correctDay.valueOf() as number};*/
					if (val == null) return;
					const updates = {startTime: Moment(dayStartTime).set({hour: val.get("hour"), minute: val.get("minute")}).valueOf()};
					new UpdateTimelineEvent({id: event.id, updates}).RunOnServer();
				}}/>
				<Text ml={5}>End time: </Text>
				<VDateTime dateFormat={false} value={event.endTime ? Moment(event.endTime) : null} min={event.startTime ? Moment(event.startTime) : null} onChange={val=>{
					const updates = {endTime: val ? Moment(dayStartTime).set({hour: val.get("hour"), minute: val.get("minute")}).valueOf() : undefined};
					new UpdateTimelineEvent({id: event.id, updates}).RunOnServer();
				}}/>
				<Text ml={5}>Activity: </Text>
				<Select options={activities.map(a=>({name: a.name, value: a.id}))} value={event.activity}
					onChange={val=>{
						const updates = {activity: val};
						new UpdateTimelineEvent({id: event.id, updates}).RunOnServer();
					}}/>
				{event.sessionID &&
					<Button ml={5} text="Show session" onClick={()=>{
						RunInAction("EventEditorUI.ShowSession.onClick", ()=>{
							store.main.page = "timeline";
							store.main.timeline.subpage = "sessions";
							store.main.timeline.sessions.selectedSession = event.sessionID;
						});
					}}/>}
				<Button ml={5} text="X" onClick={()=>{
					ShowMessageBox({
						title: "Delete event?", cancelButton: true,
						message: "Permanently delete this timeline event?",
						onOK: ()=>{
							new DeleteTimelineEvent({id: event.id}).RunOnServer();
						},
					});
				}}/>
			</Row>
		</Column>
	);
});